import { getAuthRequestBaseUrl } from "config/authApi";
import { wafFetch } from "services/awsWaf";

const buildUrl = (path) => {
  const base = getAuthRequestBaseUrl().replace(/\/$/, "");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
};

const parseResponseBody = async (response) => {
  const text = await response.text();
  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch {
    return { message: text };
  }
};

const requestAuthEndpoint = async (path, body) => {
  const response = await wafFetch(buildUrl(path), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  const data = await parseResponseBody(response);

  if (!response.ok) {
    const message =
      data?.message ||
      data?.error ||
      `Request failed with status ${response.status}`;
    const error = new Error(message);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
};

export const signUp = ({ name, email }) =>
  requestAuthEndpoint("/signup", {
    name: String(name || "").trim(),
    email: String(email || "").trim(),
  });

export const requestPasswordReset = ({ email }) =>
  requestAuthEndpoint("/forgetPassword", {
    email: String(email || "").trim(),
  });

export const confirmPasswordReset = ({ email, code, password }) =>
  requestAuthEndpoint("/forgetPassword", {
    email: String(email || "").trim(),
    code: String(code || "").trim(),
    password: String(password || ""),
  });
